/**
* DevExpress Dashboard (_docking-layout-fullscreen-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Disposable } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import { createJQueryCallbacks } from '../../data/_jquery-helpers';
import { SingleItemSizeController } from '../internal/_interfaces';
import { SplitterSize } from './core/_layout-item';
export class FullscreenItemModel extends Disposable {
    get maximizedItemName() {
        if (this._visible() && this.dashboardItem()) {
            return this.dashboardItem().componentName();
        }
        else {
            return '';
        }
    }
    constructor(dashboardContext, localContext, repaintRequest = createJQueryCallbacks()) {
        super();
        this.dashboardContext = dashboardContext;
        this.localContext = localContext;
        this.repaintRequest = repaintRequest;
        this._dashboardItem = ko.observable(null);
        this._visible = ko.observable(false);
        this.addDisposable(this.dashboardItem = ko.computed(() => this._dashboardItem()));
        this.addDisposable(this.visible = ko.computed(() => this._visible()));
        this.addDisposable(this.viewModel = ko.computed(() => {
            return {
                dashboardItem: this.dashboardItem(),
                dashboardContext: this.dashboardContext,
                localContext: this.localContext,
                repaintRequest: this.repaintRequest,
                getSizeController: (element) => new SingleItemSizeController(element.closest('.dx-dashboard-fullscreen-item-base'), this.repaintRequest, SplitterSize)
            };
        }));
    }
    dispose() {
        super.dispose();
        this.removeProperties();
    }
    maximizeItem(dashboardItem) {
        this._dashboardItem(dashboardItem);
        this._visible(true);
    }
    restoreDownItem() {
        this._visible(false);
    }
}
